var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"foot"}},[_c('b-navbar',{attrs:{"fixed":"bottom","type":"dark","variant":"info","sticky":_vm.isSticky}},[_c('b-nav-text',[_vm._v("Navbar text")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }